import React, { useState } from "react";
import { Plus, SendHorizontal } from "lucide-react";

import { chatText } from "../messages";

const MAX_ROWS = 5;

export function ChatComposer({
  onSend,
  disabled = false,
  isPending = false,
  placeholderKey = "chat.composer.placeholder",
}) {
  const [input, setInput] = useState("");
  const canSend = Boolean(input.trim()) && !disabled && !isPending;

  function submit(event) {
    event?.preventDefault();
    if (!canSend) return;
    onSend(input.trim());
    setInput("");
  }

  function onKeyDown(event) {
    if (event.key === "Enter" && !event.shiftKey && !event.nativeEvent?.isComposing) {
      submit(event);
    }
  }

  const rows = Math.min(MAX_ROWS, Math.max(1, input.split("\n").length));

  return (
    <form onSubmit={submit} className="flex items-end gap-2 border-t border-black/[0.05] bg-[#F5F2EB] px-3 py-3">
      <button
        type="button"
        aria-label={chatText("chat.composer.attach")}
        className="mb-0.5 rounded-full p-2 text-[#0A4730]/50"
        disabled
      >
        <Plus size={20} />
      </button>
      <div className="flex min-h-11 flex-1 items-center rounded-2xl bg-white px-4 shadow-sm">
        <textarea
          aria-label={chatText("chat.composer.label")}
          value={input}
          rows={rows}
          onChange={(event) => setInput(event.target.value)}
          onKeyDown={onKeyDown}
          placeholder={chatText(placeholderKey)}
          disabled={disabled}
          autoComplete="off"
          className="w-full resize-none bg-transparent py-3 text-[13px] text-[#042416] outline-none placeholder:text-[#0A4730]/35 md:text-sm"
        />
      </div>
      <button
        type="submit"
        aria-label={chatText("chat.composer.send")}
        disabled={!canSend}
        className="mb-0.5 flex h-10 w-10 items-center justify-center rounded-full bg-[#0A4730] text-white transition active:scale-95 disabled:opacity-35"
      >
        <SendHorizontal size={17} />
      </button>
    </form>
  );
}
